<script>
export default {
    name: 'SalesReceipt',

     data() {

        return {
            transactions: [],
            summary: {},
        };
    },

    mounted() {

        this.fetchAll().then(() => {
            this.fetchSummary().then(() => {
                window.print();
            }).catch(() => {});
        }).catch(() => {});
    },

    methods: {

        fetchAll() {

            return this.$accountsHttp
                .get(`SupplierStatement/GetSupplierStatement?supplierId=${this.$router.query.supplierID}&dateFrom=${this.$router.query.dateFrom}&dateTo=${this.$router.query.dateTo}`)
                .then(response => {
                    this.transactions = response.data;
            }).catch(() => {});
        },

        fetchSummary() {

            return this.$accountsHttp.get(`SupplierStatement/GetSupplierStatementSummary?supplierId=${this.$router.query.supplierID}&dateFrom=${this.$router.query.dateFrom}&dateTo=${this.$router.query.dateTo}`).then(response => {
                this.summary = response.data;
            }).catch(() => {});
        },
    },
}
</script>

<template>
    <div class="w-full">
        <div class="flex justify-center p-2">
            <h3 class="text-center font-bold text-blue-400 text-sm">SUPPLIER STATEMENT</h3>
        </div>
        <table class="table table-bordered my-3">
            <thead class="font-semibold text-sm">
                <tr>
                    <th class="p-tiny">Trans Date</th>
                    <th class="p-tiny">Trans Type</th>
                    <th class="p-tiny">Trans Ref</th>
                    <th class="p-tiny">Trans Desc</th>
                    <th class="p-tiny">Debit</th>
                    <th class="p-tiny">Credit</th>
                    <th class="p-tiny">Running Balance</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(transaction, index) in transactions" :key="index">
                    <td class="p-tiny">{{ transaction.transDate }}</td>
                    <td class="p-tiny">{{ transaction.transType }}</td>
                    <td class="p-tiny">{{ transaction.transRef }}</td>
                    <td class="p-tiny">{{ transaction.transDesc }}</td>
                    <td class="p-tiny">{{ transaction.debit }}</td>
                    <td class="p-tiny">{{ transaction.credit }}</td>
                    <td class="p-tiny">{{ transaction.runningBalance | numberFormat }}</td>
                </tr>
            </tbody>
        </table>
        <div class="flex w-full flex-wrap mt-3">
            <div class="flex-1 p-1">
                <h5 class="font-bold text-sm">0-30 Days: {{ summary._0to30Days ? ( summary._0to30Days | numberFormat ) : '-' }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-bold text-sm">31-60 Days: {{ summary._31to60Days ? ( summary._31to60Days | numberFormat) : '-' }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-bold text-sm">91-120 Days: {{ summary._61to90Days ? (summary._61to90Days | numberFormat) : '-' }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-bold text-sm">Over-120 Days: {{ summary.over120Days ? (summary.over120Days | numberFormat) : '-'  }}</h5>
            </div>
            <div class="flex-1 p-1">
                <h5 class="font-bold text-sm">Totals: {{ summary.runningBalance ? (summary.runningBalance | numberFormat) : '-' }}</h5>
            </div>
        </div>
    </div>
</template>
